import React from 'react';
import '../../styles/PartnerTestimonial.css';

function PartnerTestimonialFull() {
  const testimonials = [
    {
      id: 1,
      quote: `Simon Yio strikes you immediately as an excellent teacher... His knowledge of the subject, ability to communicate that knowledge... His teaching style is wonderful, full of humor and stories, and most importantly real-world examples... Simon Yio was always there for my support... He gives you the constant feeling you are dealing with a friend who cares... I will always appreciate him for empowering me with the ability to negotiate with confidence and with understanding.`,
      author: 'Amr Mohssen',
    },
    {
      id: 2,
      quote: `Thank you for being a caring and dynamic team leader... You are truly a leader, and have groomed many of us to where we are today... As a mentor, you are always there to help anyone resolve issues... With the enthusiasm you have in creating and facilitating course programs, you act more like a mentor and a friend... I was motivated by you when you shared how to build a strong sales team... You want to see us succeed in this industry, whether in personal sales or in building a sales team.`,
      author: 'Andrew Se',
    },
    {
      id: 3,
      quote: `Mr. Simon Yio is different from other leaders... He advised me to reconsider and visit more agencies, showing his professionalism and care... Despite leading a team of over 200 associates, his enthusiasm to help has never faded... With his years of industry knowledge, training, and guidance, I’ve built a successful career... He reminds us to be professional and ethical... His performance exceeds my expectations, and he conducts himself with maturity, diligence, and trustworthiness... I’m glad to have him as my team leader and mentor.`,
      author: 'Billion Tan',
    },
    {
      id: 4,
      quote: `I joined OrangeTee in June 2009 under Simon Yio... Simon's leadership style is proactive, and he facilitates training with full enthusiasm, acting more like a mentor and friend... He is a great listener with deep understanding of people... He gave me guidance, challenges, and clear directions... His excitement for my future in real estate motivated me instantly... I refer to Simon as a true model with a heart. I am thoroughly pleased with your generosity in sharing!`,
      author: 'Bonnie Yeoh',
    },
    {
      id: 5,
      quote: `I am grateful to meet Simon Yio, our Team Leader and Trainer, since joining OrangeTee in 2009... His skillful, patient, and enthusiastic teaching gave me the confidence to succeed in the trade... Simon has demonstrated excellent leadership and supervisory skills... He works well with diverse groups and has helped expand the team... His confident and optimistic mindset inspires agents to succeed... His vision and guidance provided clear direction for my career... I highly praise and recommend Simon for his experience and training.`,
      author: 'Jacqualine Chaim',
    },
    {
      id: 6,
      quote: `I joined in May 2009 under Simon Yio's management, impressed by his people skills, commitment to improvement, and leadership by example... He understands his colleagues, provides moral support, and strives to better his team's performance... He leads with integrity, patience, and perseverance, building his team from scratch in 1.5 years... Simon's ability to guide associates has helped me grow significantly in my career... It has been a pleasure working with Simon, a leader worth respecting and growing with.`,
      author: 'Jasmine Lau',
    },
    {
      id: 7,
      quote: `Your guidance and mentoring through difficult times have benefited me greatly. You taught me the professional and ethical ways of handling transactions and being an honest person. I’ve personally witnessed your integrity and the way you manage clients' expectations. Thank you for never leaving anyone behind and for passing down your knowledge and skills so generously`,
      author: 'Jason Tan',
    },
    {
      id: 8,
      quote: `I had the privilege of attending a leadership course facilitated by Mr. Simon Yio, former COO of OrangeTee & Tie. His insightful and engaging approach deepened our understanding of leadership styles and encouraged meaningful self-discovery. Through his guidance, I gained valuable insights into my own leadership strengths and areas for growth. Mr. Yio’s dedication and ability to connect personally with each participant made the course a truly transformative experience.`,
      author: 'Geryl Lim',
    },
    {
      id: 9,
      quote: `I had the privilege to attend Simon Yio's sales training, and it was an enriching experience. His sessions combined industry expertise with practical strategies, tailored to meet our needs. I gained confidence in presenting properties, handling objections, and closing deals. The focus on interpersonal skills and understanding client needs was especially impactful. I’m grateful to have learned from such a seasoned professional and highly recommend Simon as a trainer.`,
      author: 'Lisa Seow',
    },
    {
      id: 10,
      quote: `I’ve known Simon for over 20 years and always admired his resilience, positivity, and faith in God. No matter the adversity, he rises stronger each time. Simon’s tenacity and character are inspiring. Professionally, he excels in sales and public speaking—his ability to engage, inspire, and train is exceptional. His training programs are transformative, empowering others with confidence and practical skills. Simon is a mentor and leader from whom anyone can learn. I’m honored to know him and have gained much from his wisdom and guidance.`,
      author: 'Ronnie Ong',
    },
    {
      id: 11,
      quote: `It was a pleasure attending Simon Yio's leadership training in 2022. His engaging style, clear messages, and Toastmasters experience set his sessions apart. Simon encouraged interaction and facilitated thought-provoking activities. Having known Simon through Toastmasters, I can attest to his genuine passion for empowering others, exemplifying transformative leadership in every session.`,
      author: 'Roza Sure Bagus',
    },
    {
      id: 12,
      quote: `I've had the privilege of witnessing Simon Yio's public speaking, and each time, he impresses with his clarity and precision. His ability to simplify complex ideas and use impactful analogies makes his presentations memorable. Simon's natural charisma and passion engage audiences, whether in small or large groups, fostering connection and rapport. His exceptional speaking style captivates listeners and ensures his message resonates long after. Simon Yio is truly an inspiring and impactful public speaker.`,
      author: 'Sharon Chong',
    },
    {
      id: 13,
      quote: ` He takes the effort to come down to most agents’ level and understanding to see what we face on the ground. Be it good or bad; he is always ready to listen.`,
      author: 'Douglas Chew',
    },
    {
      id: 14,
      quote: `He is a very self-motivated, self-disciplined and self-directed person, and we have been influenced by all his virtues.`,
      author: 'Sharon Han',
    },
  ];

  return (
    <div className="partnerTestimonialFullPage">
      <h2 className="testimonialFullHeading">All Testimonials</h2>
      <div className="testimonialGrid">
        {testimonials.map((t) => (
          <div key={t.id} className="partnerTestimonialCard">
            <div className="stars">
              {[...Array(5)].map((_, i) => (
                <svg key={i} className="starIcon" viewBox="0 0 20 20" fill="#FFD700">
                  <path d="M10 1l2.47 6.97h7.35l-5.94 4.32 2.28 7.01L10 14.9l-6.16 4.41 2.28-7.01L.18 7.97h7.35L10 1z" />
                </svg>
              ))}
            </div>
            <h3 className="testimonialHeading">TESTIMONIAL</h3>
            <p className="testimonialQuote">{t.quote}</p>
            <p className="testimonialAuthor">{t.author}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PartnerTestimonialFull;
